module.exports = __webpack_public_path__ + "assets/762a4af11665127b54f170fe074510bd.mp3";